import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import * as S from './HotelSearchStyle';
import Loader from 'common/Loader/Loader';
import { Container } from 'common/Styles';
import { querySearchApi, updateFilterObj, updateSsr } from 'reduxStore/actions/miceActionDispatcher';
import Filters from './components/Filter/Filter';
import HotelTiles from './components/HotelTiles/HotelTiles';
import MobileFilter from './components/Filter/MobileFilter';
import DestinationFilter from './components/DestinationFilter/DestinationFilter';
import FilterBottomSheet from './components/BottomFilter/FilterBottomSheet';
import Modal from 'common/Modal/Modal';
import DisplayContext from 'UtilityComponents/displayContext';
import { isMobileContext } from 'UtilityComponents/Util';
import { getMiceApiParams } from 'UtilityComponents/miceUtils';
import { APPLICATION_PATH } from 'AppConstants';
import { defaultOptionSelected } from '../../config';

const HotelSearch = () => {
	const history = useHistory();
	const routeParams = useParams();
	const dispatch = useDispatch();

	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	const [filterBottomSheet, setFilterBottomSheet] = useState(false);
	const hotelSearchData = useSelector((state) => state.mice.hotelSearchData);
	const ssr = useSelector((state) => state.mice.ssr);

	const { loading: searchApiLoader, error: searchApiError } = hotelSearchData;

	const { city, destinationType, property, eventType } = routeParams;

	useEffect(() => {
		if (!ssr) {
			const miceParams = getMiceApiParams(routeParams);
			dispatch(updateFilterObj(miceParams.filter));
			dispatch(querySearchApi(miceParams));
		}
	}, [ssr, destinationType, city, eventType]);

	const updateUrl = (filterParams) => {
		const params = {
			destinationType,
			eventType,
			...filterParams
		};
		let newParams = '';
		newParams += params.destinationType ? `/${params.destinationType}` : `/${defaultOptionSelected.destinationType.urlDataKey}`;
		newParams += params.eventType ? `/${params.eventType}` : `/${defaultOptionSelected.eventType.urlDataKey}`;
		newParams += params.city ? `/${params.city}` : ``;
		dispatch(updateSsr(false));
		history.push({ pathname: APPLICATION_PATH + newParams });
	};

	const toggleFilter = () => {
		setFilterBottomSheet((prev) => !prev);
	};

	return (
		<S.SearchWrapper>
			<Container>
				<S.DestinationContainerWrapper>
					{isMobile ?
						<MobileFilter searchResults={updateUrl} toggleFilter={toggleFilter} /> :
						<Filters searchResults={updateUrl} isMobile={isMobile} />}
					<DestinationFilter searchResults={updateUrl} isMobile={isMobile} />
					{searchApiLoader || searchApiError ?
						<Loader margin='10px' color='#723b63' /> :
						<>
							<HotelTiles property={property} isMobile={isMobile} />
						</>}
				</S.DestinationContainerWrapper>
				{filterBottomSheet &&
					<Modal
						Modaldata={{
							customWrapperClass: 'mice'
						}}
						type='bottom'
						close
						handleModal={toggleFilter}
						isResponsive>
						<FilterBottomSheet searchResults={updateUrl} toggleFilter={toggleFilter} isMobile={isMobile} />
					</Modal>}
			</Container>
		</S.SearchWrapper>
	);
};

export default HotelSearch;
